module.exports = __webpack_public_path__ + "static/media/auth-brand-photo.378828d8.jpg";